<div class="flex justify-center mb-20">
  <div
    class="w-full max-w-[1500px] py-2 mt-12 px-4 max-[1520px]:px-24 max-lg:px-8"
  >
    <div class="mb-12">
      <div class="inline-block">
        <h2
          class="text-4xl md:text-5xl font-extrabold text-gray-900 tracking-tight"
        >
          Today Trends
        </h2>
        <div
          class="mt-3 h-1.5 bg-gradient-to-r from-blue-600 via-yellow-400 to-yellow-500 rounded-full w-full shadow-md"
        ></div>
      </div>
    </div>

    <!-- Horizontal Carousel with Arrows -->
    <div class="relative"
    (mouseenter)="onCarouselHover(true)"
     (mouseleave)="onCarouselHover(false)"
    >
    @if (!isLoadingNews && allNews?.length === 0) {
  <div class="flex flex-col items-center justify-center py-32">
    <img
      src="assets/images/empty.jpg"
      alt="No news available"
      class="w-[420px] max-w-full opacity-90"
    />

 
  </div>
}

      <!-- Previous Arrow - Outside left -->
      <button
        (click)="previousSlide()"
        class="absolute left-[-24px] md:left-[-40px] top-1/2 -translate-y-1/2 z-20 w-12 h-12 md:w-16 md:h-16 rounded-full bg-white shadow-2xl flex items-center justify-center hover:bg-gray-100 transition-all opacity-90 hover:opacity-100"
        [class.hidden]="currentIndex === 0 || isLoadingNews"
      >
        <mat-icon class="text-2xl md:text-3xl text-primary-500"
          >chevron_left</mat-icon
        >
      </button>

      <!-- Next Arrow - Outside right -->
      <button
        (click)="nextSlide()"
        class="absolute right-[-24px] md:right-[-40px] top-1/2 -translate-y-1/2 z-20 w-14 h-14 md:w-16 md:h-16 rounded-full bg-white shadow-2xl flex items-center justify-center hover:bg-gray-100 transition-all opacity-90 hover:opacity-100"
        [class.hidden]="!hasNextItems && !isLoadingMore"
      >
        <mat-icon class="text-2xl md:text-3xl text-primary-500"
          >chevron_right</mat-icon
        >
      </button>

      <!-- Carousel Container -->
      <div class="overflow-hidden mt-12">
        <div
          class="flex gap-6 md:gap-10 transition-transform duration-500 ease-out px-12 md:px-20"
          [style.transform]="'translateX(-' + currentIndex * slideWidth + '%)'"
        >
          <!-- Beautiful Skeleton Loaders (Initial Load) -->
          @if (isLoadingNews) { @for (item of [].constructor(6); track $index) {
          <div class="flex-shrink-0 w-full sm:w-1/2 lg:w-1/3">
            <div
              class="h-[540px] mx-auto w-full max-w-sm rounded-lg border border-gray-200 p-4 flex flex-col gap-4 bg-white shadow-sm"
            >
              <div
                class="flex-1 w-full bg-gray-200 animate-pulse rounded-lg"
              ></div>
              <div class="h-fit flex animate-pulse space-x-4">
                <div class="size-10 rounded-full bg-gray-200"></div>
                <div class="flex-1 space-y-4 py-1">
                  <div class="h-3 rounded bg-gray-200 w-32"></div>
                  <div class="space-y-3">
                    <div class="grid grid-cols-3 gap-4">
                      <div class="col-span-2 h-3 rounded bg-gray-200"></div>
                      <div class="col-span-1 h-3 rounded bg-gray-200"></div>
                    </div>
                    <div class="h-3 rounded bg-gray-200 w-3/4"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          } }

          <!-- Actual News Cards -->
          @for (theNew of allNews; track theNew.uuid; let i = $index) {
          <div class="flex-shrink-0 w-full sm:w-1/2 lg:w-1/3">
            <div
              class="group cursor-pointer transition-all duration-500 hover:scale-105"
              (click)="onReadMore(theNew)"
              role="button"
              tabindex="0"
            >
              <div
                class="relative h-[540px] bg-gray-50 backdrop-blur-xl border border-blue-200/30 group-hover:border-primary/30 rounded-lg shadow-sm overflow-hidden flex flex-col transition-all duration-500 ease-out group-hover:-translate-y-4 group-hover:bg-gray-100/30"
              >
                <div class="flex-1">
                  <div
                    class="h-full rounded- overflow-hidden w-full flex justify-center"
                  >
                    <img
                      [src]="
                        theNew.thumbnailUrl ||
                        'assets/images/default-newspaper.jpg'
                      "
                      [alt]="theNew.title"
 class="h-full w-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
                      (error)="onImageError($event)"
                      loading="lazy"
                    />
                  </div>
                  <div
                    class="absolute top-0 right-0 bg-primary-100/80 backdrop-blur px-4 py-2 rounded-sm shadow-lg z-20"
                  >
                    <p class="text-sm font-bold text-gray-800">
                      {{ formatDate(theNew.publicationDate) }}
                    </p>
                  </div>
                </div>
                <div
                  class="px-8 pb-10 pt-4 flex flex-col absolute bottom-0 z-30 bg-white/90 group-hover:bg-primary-500 backdrop-blur-sm w-full"
                >
                  <div class="flex items-start justify-between gap-4">
                    <h3
                      class="!my-0 text-xl md:text-2xl font-extrabold text-blue-800 group-hover:text-yellow-300 line-clamp-2 flex-1 pr-4"
                    >
                      {{ theNew.title }}
                    </h3>
                    <p
                      class="!my-0 text-lg !font-bold text-gray-700 group-hover:text-white"
                    >
                      {{ theNew.publicationNumber }}
                    </p>
                  </div>
                  <div class="flex items-end justify-between gap-4 mt-4">
                    @if (theNew.description) {
                    <p
                      class="text-sm text-gray-600 group-hover:text-white !font-bold line-clamp-2 flex-1 pr-4"
                    >
                      {{ theNew.description }}
                    </p>
                    }
                    <span
                      class="flex items-center gap-2 text-primary-400 font-semibold whitespace-nowrap animate-reading-pulse group-hover:text-primary-50 cursor-pointer"
                    >
                     <mat-icon class="text-base">menu_book</mat-icon>
                      <span class="tracking-wide">Start Reading</span>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          }

          <!-- Loading More Skeletons (when fetching next page) -->
          @if (isLoadingMore) { @for (item of [].constructor(3); track $index) {
          <div class="flex-shrink-0 w-full sm:w-1/2 lg:w-1/3">
            <div
              class="h-[540px] mx-auto w-full max-w-sm rounded-lg border border-gray-200 p-4 flex flex-col gap-4 bg-white shadow-sm"
            >
              <div
                class="flex-1 w-full bg-gray-200 animate-pulse rounded-lg"
              ></div>
              <div class="h-fit flex animate-pulse space-x-4">
                <div class="size-10 rounded-full bg-gray-200"></div>
                <div class="flex-1 space-y-4 py-1">
                  <div class="h-3 rounded bg-gray-200 w-32"></div>
                  <div class="space-y-3">
                    <div class="grid grid-cols-3 gap-4">
                      <div class="col-span-2 h-3 rounded bg-gray-200"></div>
                      <div class="col-span-1 h-3 rounded bg-gray-200"></div>
                    </div>
                    <div class="h-3 rounded bg-gray-200 w-3/4"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          } }
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Auth Modal (unchanged) -->
<div
  *ngIf="showAuthModal"
  class="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-60 backdrop-blur-sm"
  (click)="closeModal()"
>
  <div
    class="bg-white rounded-2xl shadow-2xl p-8 max-w-md w-full mx-4 animate-scale-in"
    (click)="$event.stopPropagation()"
  >
    <div class="text-center mb-8">
      <div
        class="mx-auto w-20 h-20 bg-blue-100 rounded-full flex items-center justify-center mb-4"
      >
        <svg
          class="w-10 h-10 text-blue-800"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"
          />
        </svg>
      </div>
      <h3 class="text-2xl font-bold text-gray-800 mb-3">Access Required</h3>
      <p class="text-gray-600">You need an account to read this publication.</p>
    </div>
    <div class="space-y-4">
      <button
        (click)="goToRegister()"
        class="w-full bg-blue-800 text-white font-semibold py-4 rounded-xl hover:bg-blue-900 transition-all shadow-lg transform hover:scale-105"
      >
        Create an Account
      </button>
      <div class="text-center text-sm text-gray-500 my-4">or</div>
      <button
        (click)="goToLogin()"
        class="w-full border-2 border-blue-800 text-blue-800 font-semibold py-4 rounded-xl hover:bg-blue-50 transition-all"
      >
        Sign In to Existing Account
      </button>
    </div>
    <button
      (click)="closeModal()"
      class="mt-6 text-gray-500 hover:text-gray-700 text-sm underline w-full text-center block"
    >
      Maybe later
    </button>
  </div>
</div>
